import { createStore } from 'redux'; // http://redux.js.org/docs/basics/
import reducer from '../../redux/reducers';

const reduxStore = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // enable redux dev tools https://github.com/zalmoxisus/redux-devtools-extension#usage
);

export {reduxStore};

const getNestedValue = (object, key) => key.split('.').reduce((obj, keyPart) => obj[keyPart], object);
export default {
    get(key) {
        if(!key) { return reduxStore.getState(); }
        return getNestedValue(reduxStore.getState(), key);
    },
    set(key, value) {
        console.error('GeckoStore: Redux should only be updated by dispatching an action http://redux.js.org/docs/basics/Actions.html have a look at GeckoStore.redux.dispatch() instead')
    },
    dispatch(...args) {
        reduxStore.dispatch(...args);
    },
    store: reduxStore
};
